import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const REMOVE_CURATED_CONTENT_TEST_NAME = 'HP_RemoveBoFCuratedContent_Aug2026';

export const trackRemoveCuratedContentTest = (): void => {
    trackAbTestV2Variant(REMOVE_CURATED_CONTENT_TEST_NAME);
};
